var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 264,
    viewBox: "0 0 1440 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_544_23175)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 264,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 60,
    width: 480,
    height: 480,
    rx: 48,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 108,
    width: 480,
    height: 480,
    rx: 48,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 156,
    width: 480,
    height: 480,
    rx: 48,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: -372,
    width: 357,
    height: 480,
    rx: 48,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 108,
    width: 480,
    height: 480,
    rx: 48,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: -372,
    width: 480,
    height: 480,
    rx: 48,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 108,
    width: 480,
    height: 480,
    rx: 48,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: -372,
    width: 456,
    height: 480,
    rx: 48,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: -372,
    width: 480,
    height: 480,
    rx: 48,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: -276,
    width: 480,
    height: 480,
    rx: 48,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 156,
    width: 48,
    height: 48,
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 60,
    width: 48,
    height: 48,
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 108,
    width: 48,
    height: 48,
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 60H408V60C408 86.5097 386.51 108 360 108V108V60Z",
    fill: "#111111",
    stroke: "url(#paint0_angular_544_23175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 108C408 81.4903 429.49 60 456 60V60V108H408V108Z",
    fill: "#111111",
    stroke: "url(#paint1_angular_544_23175)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 60,
    width: 48,
    height: 48,
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 108,
    width: 48,
    height: 48,
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 156H648V156C648 182.51 626.51 204 600 204V204V156Z",
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 156H600V204V204C573.49 204 552 182.51 552 156V156Z",
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648 156H696V156C696 182.51 674.51 204 648 204V204V156Z",
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648 60H696V108V108C669.49 108 648 86.5097 648 60V60Z",
    fill: "#111111",
    stroke: "url(#paint2_angular_544_23175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648 108V108C674.51 108 696 129.49 696 156V156H648V108Z",
    fill: "#111111",
    stroke: "url(#paint3_angular_544_23175)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 156,
    width: 48,
    height: 48,
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 60,
    width: 48,
    height: 48,
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 108,
    width: 48,
    height: 48,
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792 156H840V156C840 182.51 818.51 204 792 204V204V156Z",
    fill: "#111111",
    stroke: "url(#paint4_angular_544_23175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840 204C840 177.49 861.49 156 888 156V156V204H840V204Z",
    fill: "#111111",
    stroke: "url(#paint5_angular_544_23175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744 60H792V60C792 86.5097 770.51 108 744 108V108V60Z",
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792 108C792 81.4903 813.49 60 840 60V60V108H792V108Z",
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936 156H984V156C984 182.51 962.51 204 936 204V204V156Z",
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 984,
    y: 156,
    width: 48,
    height: 48,
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032 156H1080V156C1080 182.51 1058.51 204 1032 204V204V156Z",
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 984,
    y: 60,
    width: 48,
    height: 48,
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032 60V60C1058.51 60 1080 81.4903 1080 108V108H1032V60Z",
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032,
    y: 108,
    width: 48,
    height: 48,
    fill: "#111111",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936 60H984V108V108C957.49 108 936 86.5097 936 60V60Z",
    fill: "#111111",
    stroke: "url(#paint6_angular_544_23175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936 108V108C962.51 108 984 129.49 984 156V156H936V108Z",
    fill: "#111111",
    stroke: "url(#paint7_angular_544_23175)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_544_23175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(360 60) rotate(90) scale(48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999483,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_544_23175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(408 60) rotate(90) scale(48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999483,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_544_23175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(648 60) rotate(90) scale(48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999483,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_544_23175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(648 108) rotate(90) scale(48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999483,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_angular_544_23175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(792 156) rotate(90) scale(48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999483,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_angular_544_23175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(840 156) rotate(90) scale(48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999483,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_angular_544_23175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(936 60) rotate(90) scale(48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999483,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_angular_544_23175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(936 108) rotate(90) scale(48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999483,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_23175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 264,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBg);
export default __webpack_public_path__ + "static/media/top-bg.a4b156bdddf71cda3c34c3a8218aa8ec.svg";
export { ForwardRef as ReactComponent };